import { GaussianBlurRenderPass } from "./GaussianBlurRenderPass";

export class SsaoBlurRenderPass extends GaussianBlurRenderPass {
    createColorTexture(width: number, height: number): WebGLTexture {
        const textureID = this.gl.createTexture();
        this.gl.bindTexture(this.gl.TEXTURE_2D, textureID);
        this.gl.texParameterf(this.gl.TEXTURE_2D, this.gl.TEXTURE_MIN_FILTER, this.gl.NEAREST);
        this.gl.texParameterf(this.gl.TEXTURE_2D, this.gl.TEXTURE_MAG_FILTER, this.gl.NEAREST);
        this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, this.gl.CLAMP_TO_EDGE);
        this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, this.gl.CLAMP_TO_EDGE);

        const glFormat = this.gl.RED;
        const glInternalFormat = this.gl.R8;
        const glType = this.gl.UNSIGNED_BYTE;

        this.gl.texImage2D(this.gl.TEXTURE_2D, 0, glInternalFormat, width, height, 0, glFormat, glType, null);

        return textureID!;
    }
}
